import EbookService from '../api/ebook';
export default {
    ebook: new EbookService(),
};
//# sourceMappingURL=index.js.map